var map = {
	"./Algonquin College.png": 155,
	"./Boreal College.jpg": 156,
	"./Brescia College.jpg.png": 157,
	"./Cambrian College.jpg.png": 158,
	"./Canadore College.jpg.png": 159,
	"./Centennial College.png": 160,
	"./Conestoga College.png": 161,
	"./Confederation College.jpg.png": 162,
	"./Durham College.jpg": 163,
	"./Fanshawe College.jpg-2.png": 164,
	"./Fleming College.jpg.png": 165,
	"./George Brown College.jpg.png": 166,
	"./Georgian College.jpg.png": 167,
	"./Humber College.jpg.png": 168,
	"./Huron College.jpg.png": 169,
	"./Kings College.png": 170,
	"./La Cite College.jpg.png": 171,
	"./Lambton College.jpg": 172,
	"./Loyalist College.png": 173,
	"./McMaster Divinity College.jpg": 174,
	"./Mohawk College.jpg": 175,
	"./Niagara College.png": 176,
	"./Northern College.png": 177,
	"./Queens School of Religion.jfif": 178,
	"./Sault College.jpg": 179,
	"./Seneca College.jpg": 180,
	"./Sheridan College.png": 181,
	"./St Clair College.png": 182,
	"./St Lawrence College.png": 183,
	"./St Peters Seminary.png": 184,
	"./Trinity College.png": 185,
	"./Wycliffe College.png": 186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;